export default __webpack_public_path__ + "static/media/Footpad's Bands of the Tenth Court.3042cc28.jpg";